import { PaymentPlanLine, PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '../../../../../../../../config/types';
import { StatusTag } from '../../../../../../../shared/components/StatusTag/StatusTag';
import {
  OverduePlanLineStatus,
  PaymentPlanLineStatusExtended,
} from '../../../../../types/PaymentPlanLineStatusExtended';

interface PaymentPlanLineStatusTagProps {
  paymentPlanLine: PaymentPlanLine;
}

export const PaymentPlanLineStatusTag = ({ paymentPlanLine }: PaymentPlanLineStatusTagProps) => {
  const paymentPlanLineStatusParams = getParamsByPaymentPlanLineStatus(paymentPlanLine);

  if (paymentPlanLineStatusParams === undefined) return <></>;

  return (
    <>
      <StatusTag
        type={paymentPlanLineStatusParams.type}
        labelTextId={`PAYMENT_PLAN_LINE_${paymentPlanLineStatusParams.status}`}
      />
    </>
  );
};

interface PaymentPlanLineStatusParams {
  type: StatusTagType;
  status: PaymentPlanLineStatusExtended;
}

const getParamsByPaymentPlanLineStatus = (
  paymentPlanLine: PaymentPlanLine,
): PaymentPlanLineStatusParams | undefined => {
  const isPaymentOverdue = Date.now() > paymentPlanLine.dueDate.getTime();
  if (isPaymentOverdue && !paymentPlanLine.paymentDate && paymentPlanLine.status === PaymentPlanLineStatus.PENDING)
    return { type: StatusTagType.ERROR, status: OverduePlanLineStatus.OVERDUE };
  switch (paymentPlanLine.status) {
    case PaymentPlanLineStatus.PENDING:
      return { type: StatusTagType.INFO, status: paymentPlanLine.status };
    case PaymentPlanLineStatus.PROCESSING:
      return { type: StatusTagType.WARNING, status: paymentPlanLine.status };
    case PaymentPlanLineStatus.PAID:
      return { type: StatusTagType.SUCCESS, status: paymentPlanLine.status };
    case PaymentPlanLineStatus.CANCELLED:
      return { type: StatusTagType.DEFAULT, status: paymentPlanLine.status };
    default:
      return undefined;
  }
};
